/*
 * Load any Bootstrap jQuery plugins as well as any other vendor plugins.
 * This code may be modified to fit the specific needs of your application.
 */
// Full Bootstrap Library
//import 'bootstrap';

// Individual Components
// ALWAYS include if using ANY Bootstrap JS
// @see https://getbootstrap.com/docs/4.5/getting-started/webpack/#importing-javascript
import 'bootstrap/js/dist/util';

import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/popover';
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import 'bootstrap/js/dist/tooltip';

// All of FontAwesome
//import '@fortawesome/fontawesome-pro/js/all';

// // Specific packs
// import '@fortawesome/fontawesome-pro/js/light';
// import '@fortawesome/fontawesome-pro/js/regular';
// import '@fortawesome/fontawesome-pro/js/solid';
// import '@fortawesome/fontawesome-pro/js/brands';
// // Required when using specific packs
// import '@fortawesome/fontawesome-pro/js/fontawesome';

// Import app dependencies
import Router from './util/Router';

// Import app components
//import './components/Example'; // blank example

// Import app routes
import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';

// Export global components
import * as exports from './exports';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // Blog
    blog,
});

// Load Events
if (document.readyState !== 'loading') {
    routes.loadEvents();
} else {
    document.addEventListener('DOMContentLoaded', () => routes.loadEvents());
}
